import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { QrCode, ArrowLeft, Buildings, Globe, MapPin, Phone, EnvelopeSimple } from "@phosphor-icons/react";
import { useLang } from "../context/LangContext";
import { Footer } from "../components/Footer";

export default function About() {
  const { t, lang, toggle } = useLang();
  const a = t.about;
  const rows = [
    { Icon: Globe, content: <a href="https://www.aldebran.com" target="_blank" rel="noreferrer" className="hover:text-emerald-600 transition-colors" data-testid="about-website">{a.website}</a> },
    { Icon: MapPin, content: a.address },
    { Icon: Phone, content: <a href="tel:+390350167428" className="hover:text-emerald-600 transition-colors" data-testid="about-phone">{a.phone}</a> },
    { Icon: EnvelopeSimple, content: <a href="mailto:certificoqr@aldebran.com" className="hover:text-emerald-600 transition-colors" data-testid="about-email">{a.email}</a> },
  ];

  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="about-page">
      <header className="border-b border-slate-200">
        <div className="mx-auto max-w-3xl px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5" data-testid="about-logo">
            <div className="flex h-8 w-8 items-center justify-center bg-[#0A0F1A] rounded-[4px]"><QrCode size={18} weight="bold" className="text-white" /></div>
            <span className="font-display font-bold text-[17px] tracking-tight">Certifico<span className="text-emerald-500">QR</span></span>
          </Link>
          <button onClick={toggle} className="font-mono-tech text-xs font-semibold border border-slate-300 rounded-[4px] px-2 py-1" data-testid="about-lang-toggle">{lang.toUpperCase()}</button>
        </div>
      </header>

      <main className="flex-1 mx-auto w-full max-w-3xl px-6 py-14">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}>
          <p className="font-mono-tech text-xs uppercase tracking-[0.25em] text-emerald-600">{a.overline}</p>
          <h1 className="mt-3 font-display font-bold text-3xl sm:text-4xl tracking-tight text-[#0F172A]" data-testid="about-title">{a.title}</h1>

          <div className="mt-10 rounded-md border border-slate-200 bg-[#F8F9FA] p-8">
            <div className="flex items-center gap-3">
              <div className="flex h-11 w-11 items-center justify-center rounded-[4px] bg-[#0A0F1A]"><Buildings size={22} className="text-emerald-500" /></div>
              <p className="font-display font-bold text-lg text-[#0F172A]" data-testid="about-text">{a.text}</p>
            </div>
            <ul className="mt-7 space-y-4">
              {rows.map(({ Icon, content }, i) => (
                <li key={i} className="flex items-center gap-3 text-[15px] text-slate-600">
                  <Icon size={18} className="text-emerald-600 shrink-0" />
                  <span>{content}</span>
                </li>
              ))}
            </ul>
          </div>

          <Link to="/" className="mt-12 inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-[#0F172A] transition-colors" data-testid="about-back">
            <ArrowLeft size={16} /> {a.back}
          </Link>
        </motion.div>
      </main>

      <Footer />
    </div>
  );
}
